const TELEMED_YANDEX_GOALS = {
  appointmentOpen: 'telemed__appointmentOpen', // Пользователь перешёл в форму записи
  appointmentPhoneConfirmed: 'telemed__appointmentPhoneConfirmed', // Пользователь подтвердил номер телефона
  appointmentSuccess: 'telemed__appointmentSuccess', // Пользователь успешно записался и перенаправляется на МТ
}

export default TELEMED_YANDEX_GOALS
